// extracted by mini-css-extract-plugin
export default {"container":"icon_container__nsLSM","closeIcon":"icon_closeIcon__+ohMe"};